import { render, staticRenderFns } from "./station-ad-setting.vue?vue&type=template&id=2ab60f2a&scoped=true&"
import script from "./station-ad-setting.vue?vue&type=script&lang=js&"
export * from "./station-ad-setting.vue?vue&type=script&lang=js&"
import style0 from "./station-ad-setting.vue?vue&type=style&index=0&id=2ab60f2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab60f2a",
  null
  
)

export default component.exports